import { tv } from 'tailwind-variants';

export const fieldStyles = tv({
  base: 'font-body-md font-medium text-text-primary placeholder:text-text-tertiary transition-all',
  variants: {
    variant: {
      default:
        'bg-bg-inter-secondary-default group-hover:bg-bg-inter-secondary-hover focus:bg-bg-inter-secondary-default rounded-sm',
      unstyled: 'border-none outline-none',
    },
    size: {
      sm: 'p-2 h-8',
      md: 'p-2 h-10',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'sm',
  },
});
